import { Vehicle } from '@otw/models'

export const isPickupLocationComplete = (vehicle: Vehicle): boolean => {
  const pickup = vehicle.pickup_location
  if (!pickup) return false

  return Boolean(
    pickup.address?.trim() &&
      pickup.city?.trim() &&
      pickup.state?.trim() &&
      pickup.zip?.trim() &&
      pickup.contact_name?.trim() &&
      pickup.contact_phone?.trim(),
  )
}

export const vehicleNeedsPickupAddress = (vehicle: Vehicle): boolean => {
  if (vehicle.refinance === true) return false
  return vehicle.ready_for_transport?.needs_address === true && !isPickupLocationComplete(vehicle)
}
